import { render, staticRenderFns } from "./InputStart.vue?vue&type=template&id=31f42383&scoped=true&"
import script from "./InputStart.vue?vue&type=script&lang=js&"
export * from "./InputStart.vue?vue&type=script&lang=js&"
import style0 from "./InputStart.vue?vue&type=style&index=0&id=31f42383&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f42383",
  null
  
)

export default component.exports